(() => {
  const init = root => {
    if (root.dataset.fontPickerReady) return;
    root.dataset.fontPickerReady = 'true';
    const pickers = [];
    root.querySelectorAll('.ok-edit-font,[data-glass-font]').forEach(select => {
      const details = document.createElement('details');
      details.className = 'ok-font-picker';
      const summary = document.createElement('summary');
      summary.setAttribute('aria-label', 'Font');
      const label = document.createElement('span');
      const arrow = document.createElement('span');
      arrow.textContent = '⌄';
      arrow.setAttribute('aria-hidden', 'true');
      summary.append(label, arrow);
      const list = document.createElement('div');
      list.className = 'ok-font-picker__list';list.setAttribute('popover','auto');
      let group = '';
      [...select.options].forEach(option => {
        const folder = option.parentElement.tagName === 'OPTGROUP' ? option.parentElement.label : '';
        if (folder && folder !== group) {
          const heading = document.createElement('strong');
          heading.className = 'ok-font-picker__group';
          heading.textContent = folder;
          list.append(heading);
        }
        group = folder;
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = option.textContent;
        button.style.fontFamily = JSON.stringify(option.value) + ', sans-serif';
        button.dataset.fontValue = option.value;
        button.addEventListener('click', () => {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          details.open = false;
          refresh();
          summary.focus({ preventScroll: true });
        });
        list.append(button);
      });
      details.append(summary, list);
      select.after(details);
      select.classList.add('ok-font-native');
      if(!matchMedia('(max-width:620px)').matches){select.tabIndex=-1;select.setAttribute('aria-hidden','true')}
      const refresh = () => {
        label.textContent = select.selectedOptions[0]?.textContent || select.value;
        label.style.fontFamily = JSON.stringify(select.value) + ', sans-serif';
        list.querySelectorAll('button').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.fontValue === select.value));
        });
      };
      details.addEventListener('toggle', () => {
        if (details.open) {
          pickers.forEach(picker => { if (picker.details !== details) picker.details.open = false; });
          refresh();
          if(matchMedia('(max-width:620px)').matches){details.open=false;select.focus();return}
          const box=summary.getBoundingClientRect(),viewport=window.visualViewport;const height=viewport?.height||innerHeight,width=viewport?.width||innerWidth;const roomBelow=height-box.bottom,roomAbove=box.top;list.style.width=Math.min(300,width-24)+'px';list.style.left=Math.max(12,Math.min(width-Math.min(300,width-24)-12,box.left))+'px';list.style.maxHeight=Math.max(120,Math.min(340,Math.max(roomBelow,roomAbove)-16))+'px';if(roomBelow>=Math.min(200,roomAbove)){list.style.top=(box.bottom+4)+'px';list.style.bottom='auto'}else{list.style.top='auto';list.style.bottom=(innerHeight-box.top+4)+'px'}list.showPopover();
        }else if(list.matches(':popover-open'))list.hidePopover();
      });
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') { details.open = false; summary.focus(); }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          details.open = true;
          const buttons = [...list.querySelectorAll('button')];
          const index = buttons.indexOf(document.activeElement);
          buttons[Math.max(0, Math.min(buttons.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)))].focus();
        }
      });
      list.addEventListener('toggle',()=>{if(!list.matches(':popover-open'))details.open=false});
      pickers.push({ details, refresh });
      refresh();
    });
    const refreshAll = () => requestAnimationFrame(() => pickers.forEach(picker => picker.refresh()));
    ['input', 'change', 'click', 'keyup'].forEach(event => root.addEventListener(event, refreshAll));
    document.addEventListener('pointerdown', event => pickers.forEach(picker => {
      if (!picker.details.contains(event.target)) picker.details.open = false;
    }));
  };
  document.querySelectorAll('.ok-config').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.ok-config').forEach(init));
})();

